import React, { forwardRef } from 'react'
import './index.css'

const ContextModal = ({ children }, ref) => {
    return (
        <div className="context-popup-container" ref={ref}>
            <div className="context-popup-wrapper">{children}</div>
        </div>
    )
}

export default forwardRef(ContextModal)
